import React from 'react'
import { Control } from 'react-hook-form'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

import { PdfTypeEnum } from '../../../../../../../../lib/graphql'
import PdfCheckbox from '../../../buttons-by-step/utils/pdf-checkbox/PdfCheckbox'

interface IFooterProps {
  control: Control<any, any>
  clientRequestId: string
  clientProposalId: string
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const Footer = ({
  control,
  clientRequestId,
  clientProposalId,
  setIsLoading,
}: IFooterProps) => {
  const intl = useIntl()
  return (
    <div className={s.footer}>
      <PdfCheckbox
        name='isConfirmedCGU'
        control={control}
        clientProposalId={clientProposalId}
        clientRequestId={clientRequestId}
        setIsLoading={setIsLoading}
        pdfCheckboxText={[
          {
            label: intl.formatMessage({
              id: 'ui.UploadQuotationModal.Footer.checkboxText1',
              defaultMessage:
                'En cochant cette case, vous confirmez avoir lu et accepté les ',
            }),
          },
          {
            label: intl.formatMessage({
              id: 'ui.UploadQuotationModal.Footer.checkboxText2',
              defaultMessage: 'Conditions générales d’utilisation',
            }),
            url: `${process.env.NEXT_PUBLIC_APP_URL}/conditions-generales`,
          },
          {
            label: intl.formatMessage({
              id: 'ui.UploadQuotationModal.Footer.checkboxText3',
              defaultMessage: ', le ',
            }),
          },
          {
            label: intl.formatMessage({
              id: 'ui.UploadQuotationModal.Footer.checkboxText4',
              defaultMessage: 'Contrat de Mandat',
            }),
            pdfType: PdfTypeEnum.OWNER_MANDATE_CONTRACT_UNSIGNED,
          },
          {
            label: intl.formatMessage({
              id: 'ui.UploadQuotationModal.Footer.checkboxText5',
              defaultMessage: ' et reconnaissez que vos ',
            }),
          },
          {
            label: intl.formatMessage({
              id: 'ui.UploadQuotationModal.Footer.checkboxText6',
              defaultMessage:
                'Conditions Générales d’Exécution de la prestation',
            }),
            pdfType: PdfTypeEnum.OWNER_SPECIAL_CONDITIONS,
          },
          {
            label: intl.formatMessage({
              id: 'ui.UploadQuotationModal.Footer.checkboxText7',
              defaultMessage:
                ' déposées sur le site de Naboo constituent vos dernières conditions générales applicables à l’exécution de la prestation.',
            }),
          },
        ]}
      />

      <PdfCheckbox
        control={control}
        pdfCheckboxText={[
          {
            label: intl.formatMessage({
              id: 'ui.UploadQuotationModal.Footer.checkboxText8',
              defaultMessage:
                'En envoyant mon devis, je confirme que mon lieu est disponible aux dates demandées, et j’accepte que Naboo présente mon lieu au(x) client(s).',
            }),
          },
        ]}
        clientProposalId={clientProposalId}
        clientRequestId={clientRequestId}
        setIsLoading={setIsLoading}
        name='isConfirmAvailability'
      />
    </div>
  )
}

export default Footer
